export default __webpack_public_path__ + "static/media/shapes-turfStone.b65d92b9.png";